import { all } from 'redux-saga/effects/';

// global store
import client from '../../../../store/client/sagas';
import globalView from '../../../../store/view/sagas';
import globalAnalytics from '../../../../store/analytics/sagas';
import wishlist from '../../../../store/wishlist/sagas';
import bannerAppData from '../../../../store/appBanners/sagas';

import view from './view';
import searcher from './searcher';
import windowSaga from './window';
import map from './map';
import offer from './offer';
import analytics from './analytics';

import { isSSR } from '../../../../helpers/ssr';

function* sagas() {
  const availableWithSsrSagas = [
    client(),
    globalView(),
    globalAnalytics(),
    wishlist(),
    //
    view(),
    searcher(),
    offer(),
    map(),
    bannerAppData(),
  ];

  const onlyClientSagas = [windowSaga(), analytics()];

  const prepareSagas = isSSR
    ? availableWithSsrSagas
    : [...availableWithSsrSagas, ...onlyClientSagas];

  yield all(prepareSagas);
}

export default sagas;
